import { OrderForm } from "./order-form";
import { useProduct } from "@/features/product/product-context";
import { type MarketSymbol } from "@/solana/constants";
import { TradingPanelCard } from "@/features/shared/trading-panel-card";
import { useMediaQuery } from "@/hooks/use-media-query";

type OrderFormPanelProps = {
  panelId: string;
};

export const OrderFormPanel = ({ panelId }: OrderFormPanelProps) => {
  const { product } = useProduct();
  const isMobile = useMediaQuery("(max-width: 1000px)");

  if (!product) {
    return null;
  }

  return (
    <TradingPanelCard noPadding className={isMobile ? "w-full overflow-auto" : "w-[330px] overflow-x-hidden"}>
      <div className="px-2 sm:px-4 pt-2 pb-4 h-full flex flex-col justify-between min-h-[500px]">
        <OrderForm
          base={product.base}
          quote={product.quote}
          market={product.id as MarketSymbol}
          panelId={panelId}
        />
      </div>
    </TradingPanelCard>
  );
};
